import http from "./http";

//系统统计信息
export const getSystemInfo = async (data) => {
    return await http.get(`/admin/ctrl/getSystemInfo`, data);
};
//获取用户列表
export const getAppUserList = async (data) => {
    return await http.get(`/admin/ctrl/getAppUserList`, data);
};
//获取习惯列表
export const getHabitList = async (data) => {
    return await http.get(`/admin/ctrl/getPresetList`, data);
};
